// Global
import { jsx as _jsx } from "react/jsx-runtime";
import { tv } from 'tailwind-variants';
// Local
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { getTestProps } from 'lib/testing/utils';
export const Default = (props)=>{
    const phKeyLarge = `custom-container-large-${props?.params?.DynamicPlaceholderId || 'container-full-width'}`;
    const { base, container } = TAILWIND_VARIANTS();
    return /*#__PURE__*/ _jsx("div", {
        className: base(),
        ...getTestProps(`component-container-full-width-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsx("div", {
            className: container(),
            children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                name: phKeyLarge,
                rendering: props?.rendering
            })
        })
    });
};
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [
            'w-full',
            'flex',
            'flex-col',
            'md:flex-row'
        ],
        container: [
            'w-full',
            'grid',
            'grid-cols-1',
            'gap-layout-base-margin-none',
            'py-layout-base-margin-y',
            'md:py-component-section-container-padding-y'
        ]
    }
});
